import {
    OnPremPhysicalServer,
} from '@amzn/awscat-portfolio-assessment-types';

import { defaultSortBy } from '../../../../common/defaultTableSortState';
import { constants } from '../../../../common/Localization';
import AWSCATTable from '../../../../common/table/Table-index';
import { basicPhysicalServerColumns } from '../OnPremisesHelper';

export const OnPremPhysicalServerTable = (items: OnPremPhysicalServer[], currency: string): JSX.Element => {
    return (
        <AWSCATTable
            resourceName={constants.PHYSICAL_SERVERS_TYPE}
            items={items}
            columnDefinitions={basicPhysicalServerColumns(currency)}
            defaultSortBy={defaultSortBy('serverId')}
            autoGenerateVisibleContent
            enableAutoSorting
            useDefaultDownload
        />
    );
};
